import { ThemeOverlay } from "./palette.types";

export const OVERLAY_FFFFFF: ThemeOverlay = {
    2: "#FFFFFF05",
    4: "#FFFFFF0A",
    8: "#FFFFFF14",
    12: "#FFFFFF1F",
    20: "#FFFFFF33",
    40: "#FFFFFF66",
    60: "#FFFFFF99",
    80: "#FFFFFFCC",
};

export const OVERLAY_FBFBFB: ThemeOverlay = {
    2: "#FBFBFB05",
    4: "#FBFBFB0A",
    8: "#FBFBFB14",
    12: "#FBFBFB1F",
    20: "#FBFBFB33",
    40: "#FBFBFB66",
    60: "#FBFBFB99",
    80: "#FBFBFBCC",
};

export const OVERLAY_EDEDED: ThemeOverlay = {
    2: "#EDEDED05",
    4: "#EDEDED0A",
    8: "#EDEDED14",
    12: "#EDEDED1F",
    20: "#EDEDED33",
    40: "#EDEDED66",
    60: "#EDEDED99",
    80: "#EDEDEDCC",
};

export const OVERLAY_A7A7A7: ThemeOverlay = {
    2: "#A7A7A705",
    4: "#A7A7A70A",
    8: "#A7A7A714",
    12: "#A7A7A71F",
    20: "#A7A7A733",
    40: "#A7A7A766",
    60: "#A7A7A799",
    80: "#A7A7A7CC",
};

export const OVERLAY_757575: ThemeOverlay = {
    2: "#75757505",
    4: "#7575750A",
    8: "#75757514",
    12: "#7575751F",
    20: "#75757533",
    40: "#75757566",
    60: "#75757599",
    80: "#757575CC",
};
export const OVERLAY_3F4246: ThemeOverlay = {
    2: "#3F424605",
    4: "#3F42460A",
    8: "#3F424614",
    12: "#3F42461F",
    20: "#3F424633",
    40: "#3F424666",
    60: "#3F424699",
    80: "#3F4246CC",
};

export const OVERLAY_262626: ThemeOverlay = {
    2: "#26262605",
    4: "#2626260A",
    8: "#26262614",
    12: "#2626261F",
    20: "#26262633",
    40: "#26262666",
    60: "#26262699",
    80: "#262626CC",
};

export const OVERLAY_27292B: ThemeOverlay = {
    2: "#27292B05",
    4: "#27292B0A",
    8: "#27292B14",
    12: "#27292B1F",
    20: "#27292B33",
    40: "#27292B66",
    60: "#27292B99",
    80: "#27292BCC",
};
